import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { ClipboardService } from 'ngx-clipboard';

@Component({
  selector: 'app-gsuite-sync-dialog',
  templateUrl: './gsuite-sync-dialog.component.html',
  styleUrls: ['./gsuite-sync-dialog.component.scss'],
})

export class GSuiteSyncDialogComponent implements OnInit {

	constructor( @Inject(MAT_DIALOG_DATA) public data: any,
				public dialogRef: MatDialogRef<GSuiteSyncDialogComponent>,
				private translateService: TranslateService,
				private domSanitizer: DomSanitizer,
				private matIconRegistry: MatIconRegistry,
				private clipboardService: ClipboardService ) 
	{
		this.matIconRegistry.addSvgIcon(
			'trash_can',
			this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/trash.svg")
		);

		this.matIconRegistry.addSvgIcon(
			'keys',
			this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/keys.svg")
		);
	}

	tenantUrl: string = undefined;
	secretToken: string = undefined;
	showFormError: boolean = false;
	errMsg: string = "";
	errMsgStyle: any = { 'max-width': '500px' };

	ngOnInit() 
	{
		let product = this.data.product;
	}
	
	onRemoveIntegration()
	{
		console.log("Remove the integration - when successful, close the dialog");
		let result = 
		{
			remove: true,
			//is there anything else?
		}
		this.dialogRef.close( result);
	}

	onSave(event)
	{	
		console.log("Save the changes to the integration - when successful, close the dialog");
		let result = 
		{
			setupComplete: true,
			//is there anything else?
		}
		this.dialogRef.close( result);
	}

	onGenerateKeys()
	{
		this.showFormError = false;
		this.errMsg = "";
		this.data.product.service.getGSuiteSyncData(this.data.account).then( syncTokens => {
			this.tenantUrl = syncTokens.tenantUrl;
			this.secretToken = syncTokens.secret;
		})
		.catch((err) => {
			console.log('Failed to generate keys for GSuite sync', err);
			this.showFormError = true;
			this.errMsg = this.translateService.instant('integrations.error-generating-keys') + ' ' + err.body.message;
		});
	}

}
